// extracted by mini-css-extract-plugin
export var addToCartButton = "_r4-b";
export var arrowButtonContainer = "_r4-9";
export var arrowButtonIcon = "_r4-a";
export var carouselArrowButton = "_r4-6";
export var carouselElementContainer = "_r4-1";
export var left = "_r4-7";
export var productDisplayCarouselContainer = "_r4-0";
export var productTileContainer = "_r4-2";
export var productTileImage = "_r4-4";
export var productTileImageContainer = "_r4-3";
export var productTileTitle = "_r4-5";
export var right = "_r4-8";
export var sliderOverflow = "_r4-c";